import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import Nav from "./components/navigation/Nav";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { handleLogoutRedux } from "./redux/actions/userAction";

const App = () => {
  const dispatch = useDispatch();
  // const dataUserRedux = useSelector((state) => state.user.account);
  // console.log("dataUserRedux:", dataUserRedux);
  const handleTabClosing = () => {
    // Do something
    dispatch(handleLogoutRedux());
  };

  useEffect(() => {
    window.addEventListener("unload", handleTabClosing);
    return () => {
      window.removeEventListener("unload", handleTabClosing);
    };
  }, []);
  return (
    <>
      <Router>
        <div className="app-header">
          <Nav />
        </div>
        <div className="app-container">
          <AppRoutes />
        </div>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
      </Router>
    </>
  );
};
export default App;
